// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/css/iconfont.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import BaiduMap from 'vue-baidu-map'
import globalV from '@/api/globel_v';
import 'animate.css'
import {Carousel} from 'element-ui'
import {CarouselItem} from 'element-ui'
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.prototype.getData = globalV;
Vue.config.productionTip = false;

Vue.use(iView);
Vue.use(BaiduMap, {
  ak: 'dkjdz7G1QTrtyH1BfyK3neuIExaAtWQW'    //这个地方是官方提供的ak密钥
});

// 点击切换路由之后页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

import axios from 'axios'
Vue.prototype.h5s =globalV.h5
Vue.prototype.axios = axios;
Vue.prototype.baseUrl = globalV.baseUrl;
Vue.prototype.img_url = globalV.img_url;
// Vue.prototype.CDN_IMG = globalV.CDN_IMG;
Vue.prototype.$Message.config({
  top: 100,
  duration: 3
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js